import { combineReducers } from 'redux';

import chatMessage from './chatMessage/reducer';

export default combineReducers({
  chatMessage
});



/** WEBPACK FOOTER **
 ** ./src/members/state/chat/textEditing/reducer.js
 **/